define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/action/Controller"
], function(declare,lang,Controller) {

	return declare(Controller, {
		postProcessSuccess: function() {
			// summary: remove all sorting from the table
			this.widget.set("sortSettings", []);
			this.widget.showSortHeaders();
			this.widget.redrawData();
		}
	});
});